import React from 'react';

import DangKyHoSoUpdate from '../../../containers/QCV/DangKyHoSo/DangKyHoSoUpdate';

const DangKyHoSo = () => <DangKyHoSoUpdate />

export default DangKyHoSo;
